import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CreateUpdateDefaultPagePageModule} from '../../../../../../core/page/create-update-default-page/create-update-default-page.module';
import {CardModule} from '../../../../../../core/component/card/card.module';
import {MedicalRecordVisitReasonCreateUpdatePage} from './medical-record-visit-reason-create-update.page';
import {FormFieldModule} from '../../../../../../core/component/form-field/form-field.module';
import {DatePickerModule} from '../../../../../../../components/common/date-picker/date-picker.module';
import {MultipleSelectFilterModule} from '../../../../../../core/component/multiple-select-filter/multiple-select-filter.module';
import {JoinPipeModule} from '../../../../../../core/pipe/join.pipe';
import {MedicalRecordPainMultipleSelectFilterModule} from '../../../../pain/api/component/medical-record-pain-multiple-select-filter/medical-record-pain-multiple-select-filter.module';
import {FormArrayInputModule} from '../../../../../../../components/common/form-array/form-array-input/form-array-input.module';
import {MedicalRecordProblemCreateUpdateModule} from '../../../../problem/api/component/medical-record-problem-create-update/medical-record-problem-create-update.module';
import {MedicalRecordProblemMultipleSelectFilterModule} from '../../../../problem/api/component/medical-record-problem-multiple-select-filter/medical-record-problem-multiple-select-filter.module';
import {LovValuesSelectFilterModule} from '../../../../../../common/lov/lov-value/api/component/lov-values-select-filter/lov-values-select-filter.module';
import {SelectFilterModule} from '../../../../../../../components/common/select-filter/select-filter.module';
import {
    MedicalRecordVisitReasonLabelsSelectFilterModule
} from '../../../api/component/medical-record-visit-reason-labels-select-filter/medical-record-visit-reason-labels-select-filter.module';
import {DialogModule} from '../../../../../../common/dialog/dialog.module';
import {
    CreateUpdateDefaultModule
} from '../../../../../../core/component/create-update-default/create-update-default.module';
import {ButtonModule} from '../../../../../../core/component/button/button.module';
import {LoadingModule} from '../../../../../../../components/common/loading/loading.module';
import {
    MedicalRecordPainCreateUpdateModule
} from '../../../../pain/api/component/medical-record-pain-create-update/medical-record-pain-create-update.module';
import {RichTextEditorModule} from "../../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        ReactiveFormsModule,
        CreateUpdateDefaultPagePageModule,
        FormFieldModule,
        DatePickerModule,
        MultipleSelectFilterModule,
        MedicalRecordPainMultipleSelectFilterModule,
        FormArrayInputModule,
        MedicalRecordProblemCreateUpdateModule,
        MedicalRecordProblemMultipleSelectFilterModule,
        LovValuesSelectFilterModule,
        MedicalRecordPainCreateUpdateModule,
        JoinPipeModule,
        SelectFilterModule,
        MedicalRecordVisitReasonLabelsSelectFilterModule,
        DialogModule,
        CreateUpdateDefaultModule,
        ButtonModule,
        LoadingModule,
        RichTextEditorModule,
        CardV2Component
    ],
    declarations: [MedicalRecordVisitReasonCreateUpdatePage],
})
export class MedicalRecordVisitReasonCreateUpdatePageModule {
}
